import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ConfirmInvitation from './ConfirmInvitation';
import LoginPage from './LoginPage';
import TwoFACheck from './TwoFACheck';

const Auth = (): JSX.Element => {
  return (
    <Routes>
      <Route path='/' element={<LoginPage />} />
      <Route path='/2FA' element={<TwoFACheck />} />
      <Route path='/ConfirmInvitation' element={<ConfirmInvitation />} />
    </Routes>
  );
};

export default Auth;
